import React, { FC } from 'react';
import { Textfit } from 'react-textfit';
import { getSplittedTitle } from '../utils';
import { FormattedModificationGroup, useButton, useI18n } from '~Hooks';
import { ItemFragmentOnItem_upsales } from '../../GridButtons/__queries__';
import { Button } from '~Styles';
import styled from '@emotion/styled';
import { REST_TAB_KEY } from '.';

const StyledButton = styled(Button)<{ isCurrent: boolean }>`
  pointer-events: auto;
  margin: 0 8px 8px;
  min-width: 198px;
  max-width: 198px;

  height: 60px;
  min-height: 60px;

  text-transform: none;
  position: relative;

  background-color: ${({ isCurrent }) => (isCurrent ? '#fff' : 'var(--colorBlueGray200)')};

  & > div {
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
  }

  span {
    display: block;
    font-size: 80%;
    margin-bottom: 4px;
    letter-spacing: var(--letterSpacing);
  }
`;

const Pointer = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 32px;
  height: 8px;
  background-color: white;

  clip-path: path('M 0 0 Q 16 8, 32 0');
`;

interface Props {
  modificationGroup?: FormattedModificationGroup;
  upsale?: ItemFragmentOnItem_upsales;
  isCurrent: boolean;
  onTabClick: (id: string) => void;
}

/** Seperated tab button to be able to use useButton */
const TabButton: FC<Props> = ({ modificationGroup, upsale, isCurrent, onTabClick }) => {
  const { i18n } = useI18n();

  const splittedString = getSplittedTitle(
    (modificationGroup && modificationGroup.title) ?? (upsale && i18n(upsale.name)) ?? '',
  );

  const id = modificationGroup?.id ?? upsale?.id ?? REST_TAB_KEY;

  const tabButton = useButton({
    onClick: () => onTabClick(id),
  });

  return (
    <StyledButton isCurrent={isCurrent} {...tabButton}>
      {modificationGroup || upsale ? (
        <Textfit max={16} min={12}>
          {splittedString.length === 2 && <span>{splittedString[0]}</span>}
          {splittedString[1] ?? splittedString[0]}
        </Textfit>
      ) : (
        <Textfit>{i18n('POS.Rest')}...</Textfit>
      )}
      {isCurrent && <Pointer />}
    </StyledButton>
  );
};

export default TabButton;
